import { Locale } from 'chaika-enums';
export const renderedService = {
    wholeMouth: {
        [Locale.Ru]: 'Вся полость рта',
        [Locale.Am]: 'Ամբողջ բերանի խոռոչը',
        [Locale.En]: 'Whole mouth',
        [Locale.Pt]: 'Boca inteira',
        [Locale.Ge]: 'Whole mouth',
    },
    selectingTeeth: {
        [Locale.Ru]: 'Выбор зубов для услуг',
        [Locale.Am]: 'Ատամների ընտրություն ծառայությունների համար',
        [Locale.En]: 'Selecting teeth for services',
        [Locale.Pt]: 'Selecionando dentes para serviços',
        [Locale.Ge]: 'Selecting teeth for services',
    },
    toothForService: {
        [Locale.Ru]: 'Зуб для услуги',
        [Locale.Am]: 'Ատամ ծառայության համար',
        [Locale.En]: 'Tooth for service',
        [Locale.Pt]: 'Dente para serviço',
        [Locale.Ge]: 'Tooth for service',
    },
    upperJaw: {
        [Locale.Ru]: 'Верхняя челюсть',
        [Locale.Am]: 'Վերին ծնոտ',
        [Locale.En]: 'Upper jaw',
        [Locale.Pt]: 'Mandíbula superior',
        [Locale.Ge]: 'Upper jaw',
    },
    lowerJaw: {
        [Locale.Ru]: 'Нижняя челюсть',
        [Locale.Am]: 'Ստորին ծնոտ',
        [Locale.En]: 'Lower jaw',
        [Locale.Pt]: 'Mandíbula inferior',
        [Locale.Ge]: 'Lower jaw',
    },
    click: {
        [Locale.Ru]: 'Клик',
        [Locale.Am]: 'Սեղմում',
        [Locale.En]: 'Click',
        [Locale.Pt]: 'Clique',
        [Locale.Ge]: 'Click',
    },
    selectWholeTooth: {
        [Locale.Ru]: 'Выбрать весь зуб',
        [Locale.Am]: 'Ընտրել ամբողջ ատամը',
        [Locale.En]: 'Select a whole tooth',
        [Locale.Pt]: 'Selecionar um dente inteiro',
        [Locale.Ge]: 'Select a whole tooth',
    },
    tooth: {
        [Locale.Ru]: 'Зуб',
        [Locale.Am]: 'Ատամ',
        [Locale.En]: 'Tooth',
        [Locale.Pt]: 'Dente',
        [Locale.Ge]: 'Tooth',
    },
    toBePaid: {
        [Locale.Ru]: 'К оплате',
        [Locale.Am]: 'Վճարման ենթակա',
        [Locale.En]: 'To be paid',
        [Locale.Pt]: 'A ser pago',
        [Locale.Ge]: 'To be paid',
    },
    toothNumber: {
        [Locale.Ru]: 'Номер зуба',
        [Locale.Am]: 'Ատամի համար',
        [Locale.En]: 'Tooth number',
        [Locale.Pt]: 'Número do dente',
        [Locale.Ge]: 'Tooth number',
    },
    coExecutor: {
        [Locale.Ru]: 'Соисполнитель',
        [Locale.Am]: 'Համակատարող',
        [Locale.En]: 'Co-executor',
        [Locale.Pt]: 'Coexecutor',
        [Locale.Ge]: 'Co-executor',
    },
    directAttachment: {
        [Locale.Ru]: 'Выбрано прямое прикрепление',
        [Locale.Am]: 'Ընտրված է ուղիղ կցում',
        [Locale.En]: 'Direct attachment selected',
        [Locale.Pt]: 'Anexo direto selecionado',
        [Locale.Ge]: 'Direct attachment selected',
    },
    deleteService: {
        [Locale.Ru]: 'Удалить услугу',
        [Locale.Am]: 'Ջնջել ծառայությունը',
        [Locale.En]: 'Delete service',
        [Locale.Pt]: 'Excluir serviço',
        [Locale.Ge]: 'Delete service',
    },
    dept: {
        [Locale.Ru]: 'Долг',
        [Locale.Am]: 'Պարտք',
        [Locale.En]: 'Dept',
        [Locale.Pt]: 'Dívida',
        [Locale.Ge]: 'Dept',
    },
    insuranceAndDiscount: {
        [Locale.Ru]: 'Страховка и скидка',
        [Locale.Am]: 'Ապահովագրություն և զեղչ',
        [Locale.En]: 'Insurance and discount',
        [Locale.Pt]: 'Seguro e desconto',
        [Locale.Ge]: 'Insurance and discount',
    },
    insurancesDiscounts: {
        [Locale.Ru]: 'Скидки страховых',
        [Locale.Am]: 'Ապահովագրականների զեղչեր',
        [Locale.En]: 'Insurances discounts',
        [Locale.Pt]: 'Descontos de seguros',
        [Locale.Ge]: 'Insurances discounts',
    },
    bookingDoctorTime: {
        [Locale.Ru]: 'Бронирование времени доктора',
        [Locale.Am]: 'Բժշկի ժամի ամրագրում',
        [Locale.En]: `Booking a doctor's time`,
        [Locale.Pt]: 'Reserva de horário do médico',
        [Locale.Ge]: `Booking a doctor's time`,
    },
    unpaid: {
        [Locale.Ru]: 'Не оплачено',
        [Locale.Am]: 'Չվճարված',
        [Locale.En]: `Unpaid`,
        [Locale.Pt]: 'Não pago',
        [Locale.Ge]: `Unpaid`,
    },
    paid: {
        [Locale.Ru]: 'Оплачено',
        [Locale.Am]: 'Վճարված է',
        [Locale.En]: `Paid`,
        [Locale.Pt]: `Pagar`,
        [Locale.Ge]: `Paid`,
    },
    paidFem: {
        [Locale.Ru]: 'Оплачена',
        [Locale.Am]: 'Վճարված է',
        [Locale.En]: `Paid`,
        [Locale.Pt]: `Pagar`,
        [Locale.Ge]: `Paid`,
    },
    refunded: {
        [Locale.Ru]: 'Возвращено',
        [Locale.Am]: 'Վերադարձված է',
        [Locale.En]: `Refunded`,
        [Locale.Pt]: `Reembolsado`,
        [Locale.Ge]: `Refunded`,
    },
    credited: {
        [Locale.Ru]: 'Выставлен счет',
        [Locale.Am]: 'Հաշիվը դուրս է գրված',
        [Locale.En]: `Credited`,
        [Locale.Pt]: `Creditado`,
        [Locale.Ge]: `Credited`,
    },
    paymentPending: {
        [Locale.Ru]: 'В процессе оплаты',
        [Locale.Am]: 'Վճարման ընթացքում',
        [Locale.En]: `Payment pending`,
        [Locale.Pt]: `Pagamento pendente`,
        [Locale.Ge]: `Payment pending`,
    },
    refundMustBeText: {
        [Locale.Ru]: `Возврат всегда должен осуществляться тем же методом, которым производилась оплата услуги. При возврате
средств несколькими методами всегда сначала возвращайте наличные. При возврате на карту убедитесь, что у
пациента есть с собой карта.`,
        [Locale.Am]: `Վերադարձը միշտ պետք է իրականացվի նույն եղանակով, որով կատարվել է ծառայության վճարումը։ Միջոցները
մի քանի եղանակով վերադարձնելիս միշտ նախ վերադարձրեք կանխիկը։ Քարտին վերադարձնելիս համոզվեք, որ
պացիենտն իր հետ ունի քարտը։`,
        [Locale.En]: `Refunds must always be made using the same method used to pay for the service. Upon return
funds using several methods, always return the cash first. When returning to the card, make sure that you have
the patient has a card with him.`,
        [Locale.Pt]: `Os reembolsos devem ser sempre efetuados através do mesmo método de pagamento utilizado para o serviço. Ao devolver fundos por diversos métodos, devolva sempre primeiro o dinheiro em numerário. Ao devolver o valor para o cartão, certifique-se de que o paciente o tem consigo.`,
        [Locale.Ge]: `Refunds must always be made using the same method used to pay for the service. Upon return
funds using several methods, always return the cash first. When returning to the card, make sure that you have
the patient has a card with him.`,
    },
};
